"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const store_1 = require("../../context/store");
const common_1 = require("../../utils/common");
const react_1 = require("react");
/**
 * Calendar title in header in month date format
 * @param props
 * @constructor
 */
const HeaderCalendarTitle = (props) => {
    const { title } = props;
    const [store] = (0, react_1.useContext)(store_1.Context);
    const { isDark, isMobile } = store;
    return ((0, jsx_runtime_1.jsx)("div", Object.assign({ className: (0, common_1.parseClassName)(`Kalend__HeaderCalendarTitle__container`, isMobile) }, { children: (0, jsx_runtime_1.jsx)("p", Object.assign({ className: (0, common_1.parseClassName)('Kalend__text Kalend__HeaderCalendarTitle', isMobile, isDark) }, { children: title })) })));
};
exports.default = HeaderCalendarTitle;
